import React, { memo } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import arrowSvg from '../../../assets/images/arrow.svg';

const StyledFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: max-content;
`;

const StyledArrow = styled.img`
  height: 12px;
  width: 20px;
  align-self: center;
  padding: 0 15px;
  color: #102339;
`;

const StyledReadMore = styled.p`
  height: 27px;
  max-width: 150px;
  color: #1d1d1d;
  font-family: Avenir;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.15px;
  line-height: 27px;
  margin: 0;
  z-index: 1;
  padding-left: 15px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: unset;
`;

const SecondaryButtonComponent = ({ text, to }) => (
  <StyledLink to={to}>
    <StyledFlexRow>
      <StyledReadMore>{text}</StyledReadMore>
      <StyledArrow src={arrowSvg} />
    </StyledFlexRow>
  </StyledLink>
);

const SecondaryButton = memo(SecondaryButtonComponent);

SecondaryButton.defaultProps = {
  text: 'Read More',
  to: ''
};

SecondaryButton.propTypes = {
  text: PropTypes.string,
  to: PropTypes.string
};

export { SecondaryButton };
